module.exports = __webpack_public_path__ + "static/media/bottombanner.a332f718.png";